export const TRACK = 'track-analytics'
export const IDENTIFY = 'identify-analytics'
export const PAGE = 'page-analytics'
export const LINKCLICK = 'linkclick-analytics'
